"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPLOAD_FAILED = exports.UPLOADING = exports.UPLOADED = void 0;
var UPLOADING = exports.UPLOADING = 'UPLOADING';
var UPLOADED = exports.UPLOADED = 'UPLOADED';
var UPLOAD_FAILED = exports.UPLOAD_FAILED = 'FAILED';